export const TARGET_METRIC_OPTIONS = [
  'IAP ACPU',
  'IAP ARPU',
  'IAP CR',
  'AD ACPU',
  'AD ARPU',
  'AD CR',
  'RV ACPU',
  'RV ARPU',
  'RV CR',
  'IT ACPU',
  'IT ARPU',
  'IT CR',
  'SESS ACPU',
  'HB ACPU',
  'SESS LEN',
  'RR',
]

export const METRIC_DAYS_OPTIONS = [0, 1, 2, 3, 5, 7, 14, 30]
